import Vue from 'vue';
import FileUpload from 'vue-file-upload';
import Notification from 'vue-notification';
import VueRouter from 'vue-router';
import Vuetify from 'vuetify';
import { AppTheme } from './AppTheme';
import StoreFactory from './StoreFactory';
import TarifaManager from './TarifaManager';
import AppValidator from './AppValidator';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import mask from '../utils/mask';

/**
 * Config
 */
import '../config/http';

/**
 * Bn* components autoload
 */
import '../components/BnBaseComponents';
import { getCookie } from '../utils/WindowUtils';

Vue.use(VueRouter);
Vue.use(Notification);
Vue.use(FileUpload);

Vue.directive('bnmask', {
    bind: (el, binding) => {
        const interceptor = () => {
            const token = typeof binding.value === 'function' ? binding.value() : binding.value;
            const els = el.getElementsByTagName('input');
            if (
                token
                && els[0].value !== mask(els[0].value, token).nice
            ) {
                els[0].value = mask(els[0].value, token).nice;
                els[0].dispatchEvent(new CustomEvent('input'));
            }
        };
        el.addEventListener('input', interceptor);
    },
});

export default class VueApp {
    constructor(routes, tarifaModule, rootComponent, cfg) {
        this.router = new VueRouter({
            routes,
            scrollBehavior() {
                return {
                    x: 0,
                    y: 0,
                };
            },
        });

        const storeFactory = new StoreFactory(tarifaModule);
        this.store = storeFactory.getStore(cfg.pages.length);
        this.validator = new AppValidator(this.store);
        this.saveUrls = [];
        this.pages = [];
        this.cfg = cfg;
        routes.forEach((route) => {
            if (route.saveUrl) {
                this.saveUrls.push(route.saveUrl);
            }
        });

        this.cfg.pages.forEach((page) => {
            this.pages.push(page.route);
        });
        this.rootElementName = '#app';
        this.rootComponent = rootComponent;
        this.tarifaManager = new TarifaManager(this.store, this.router, this.validator, this.pages, this.saveUrls);
        this.tarifaManager.setClientValidation(this.cfg.clientValidation);

        Vue.prototype.$manager = this.tarifaManager;
        Vue.prototype.$validator = this.validator;

        /**
         * Object obj az objektum amiből értéket akaruk kinyerni
         * String path az obj objektumbeli "helye" az értéknek pl.:
         *
         * let tarifa = {
         *      szerzodo: {
         *          cim: {
         *              utca: 'Csillag'
         *          }
         *      }
         * }
         *
         * this.getNestedPropVal(tarifa, 'szerzodo.cim.csillag') // 'Csillag'
         */
        const instance = this;
        Vue.prototype.$getNestedPropVal = function getNestedPropValFn(obj, path) {
            let clonedObj = obj;
            if (typeof clonedObj === 'undefined') {
                clonedObj = instance.store.getters;
            }
            if (clonedObj === null) {
                clonedObj = instance.store.getters;
            }
            if (path.length === 1) {
                return clonedObj[path];
            }
            return this.$getNestedPropVal(clonedObj[path[0]], path.slice(1));
        };

        // let instance = this
        // Vue.prototype.$getNestedPropVal = function (obj, path) {
        //     if (typeof obj === 'undefined') {
        //         obj = instance.store.getters
        //     }
        //     if (obj === null) {
        //         obj = instance.store.getters
        //     }
        //     if (path.length === 1) {
        //         return obj[path]
        //     } else {
        //         return this.$getNestedPropVal(obj[path[0]], path.slice(1))
        //     }
        // }
        /**
         * Ugyan az csak setter
         */
        Vue.prototype.$setNestedPropVal = function setNestedPropValFn(obj, path, value) {
            const clonedObj = obj;
            let clonedPath = path;
            if (clonedPath.constructor !== Array) {
                clonedPath = clonedPath.split('.');
            }

            if (clonedPath.length === 1) {
                if (Array.isArray(value)) {
                    Vue.set(clonedObj, clonedPath, [...value]);
                } else if (typeof value === 'object' && value != null) {
                    Vue.set(clonedObj, clonedPath, { ...value });
                } else if (value == null) {
                    Vue.set(clonedObj, clonedPath, null);
                } else {
                    Vue.set(clonedObj, clonedPath, value);
                }
            } else {
                if (typeof clonedObj[clonedPath[0]] === 'undefined') {
                    clonedObj[clonedPath[0]] = {};
                }
                this.$setNestedPropVal(clonedObj[clonedPath[0]], clonedPath.splice(1), value);
            }
        };

        Vue.prototype.$deleteNestedProp = (obj, path) => {
            const clonedObj = obj;
            let clonedPath = path;
            if (clonedPath.constructor !== Array) {
                clonedPath = clonedPath.split('.');
            }

            if (clonedPath.length === 1) {
                delete clonedObj[clonedPath];
            } else {
                this.$deleteNestedProp(clonedObj[clonedPath[0]], clonedPath.splice(1));
            }
        };

        this.store.commit('setTheme', cfg.theme);
        Vue.prototype.$theme = new AppTheme(cfg.theme);

        const theme = {
            dark: false,
            themes: {},
            options: {
                customProperties: true,
            },
        };

        theme.themes.light = Vue.prototype.$theme.getTheme();

        const vueOpts = {
            theme,
            icons: {
                values: {
                    radioOff: 'check_box_outline_blank',
                    radioOn: 'check_box',
                },
            },
        };
        Vue.use(Vuetify);

        Vue.config.productionTip = true;
        Vue.config.devtools = true;

        Vue.prototype.$online = cfg.online;
        Vue.prototype.cfg = this.cfg;
        Vue.prototype.$hasLoginUser = typeof getCookie('BNETAUTH') !== 'undefined';

        /* eslint-disable no-new */
        new Vue({
            el: this.rootElementName,
            render: (h) => h(this.rootComponent, {
                props: {
                    app: this.cfg,
                },
            }),
            store: this.store,
            router: this.router,
            vuetify: new Vuetify(vueOpts),
            data: {
                cfg: this.cfg,
            },
        });
        /* eslint-enable no-new */
    }
}
